import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a24031a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import home from '@/assets/img/menu/icon-home.svg'
import homeA from '@/assets/img/menu/icon-home-active.svg'
import device from '@/assets/img/menu/icon-device.svg'
import deviceA from '@/assets/img/menu/icon-device-active.svg'
import message from '@/assets/img/menu/icon-message.svg'
import messageA from '@/assets/img/menu/icon-message-active.svg'
import position from '@/assets/img/menu/icon-position.svg'
import positionA from '@/assets/img/menu/icon-position-active.svg'
import statistics from '@/assets/img/menu/icon-statistics.svg'
import statisticsA from '@/assets/img/menu/icon-statistics-active.svg'
import warning from '@/assets/img/menu/icon-warning.svg'
import warningA from '@/assets/img/menu/icon-warning-active.svg'
import cost from '@/assets/img/menu/icon-cost.svg'
import costA from '@/assets/img/menu/icon-cost-active.svg'
import communication from '@/assets/img/menu/icon-communication.svg'
import communicationA from '@/assets/img/menu/icon-communication-active.svg'
import conf from '@/assets/img/menu/icon-conf.svg'
import confA from '@/assets/img/menu/icon-conf-active.svg'
import i18n from '@/i18n'

import { useAuthStore } from '@/stores/auth'
import { useFarmStore } from '@/stores/farm'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const farmStore = useFarmStore()
const authStore = useAuthStore()

const t = i18n.global.t

const menuData: any = [
  {
    label: t('MENU.home'),
    icon: home,
    active: homeA,
    router: '/',
  },
  {
    label: t('MENU.siteManagement'),
    icon: device,
    active: deviceA,
    router: '/site',
    code: '6',
    children: [
      {
        code: '6-1',
        label: t('MENU.siteList'),
        router: '/site/site-list',
      },
      {
        code: '6-1',
        label: t('MENU.siteDistribution'),
        router: '/site/site-location',
      },
    ],
  },
  {
    label: t('MENU.deviceManage'),
    icon: device,
    active: deviceA,
    router: '/device',
    code: '1',
    children: [
      {
        code: '1-1',

        label: t('MENU.deviceInfo'),
        router: '/device/device-list',
      },
      {
        code: '1-2',
        label: t('MENU.deviceLocation'),
        router: '/device/device-location',
      },
      {
        code: '1-3',
        label: t('MENU.deviceTrail'),
        router: '/device/device-trail',
      },
      {
        code: '1-4',
        label: t('MENU.deviceLocus'),
        router: '/device/device-locus',
      },
    ],
  },
  {
    label: t('MENU.dataManage'),
    icon: statistics,
    active: statisticsA,
    router: 'statistics',
    code: '2',
    children: [
      {
        code: '2-1',
        label: t('MENU.kanban'),
        router: '/statistics/board',
      },
      {
        code: '2-3',
        label: t('MENU.reportConfiguration'),
        router: '/statistics/report-config',
      },
      {
        code: '2-4',
        label: t('MENU.reportQuery'),
        router: '/statistics/report',
      },
      {
        code: '2-5',
        label: t('MENU.fileQuery'),
        router: '/statistics/files',
      },
      {
        code: '2-6',
        label: t('MENU.videoMonitoring'),
        router: '/statistics/videos',
      },
      {
        code: '2-2 2-7',
        codeList: ['2-2', '2-7'],
        label: t('MENU.bigScreen'),
        router: '/statistics/bigscreen',
        children: [
          {
            code: '2-2',
            label: t('MENU.bigScreenFarm'),
            router: '/statistics/bigscreen-farm',
          },
          {
            code: '2-7',
            label: t('MENU.bigScreenPark'),
            router: '/statistics/bigscreen-park',
          },
        ],
      },
    ],
  },
  {
    label: t('MENU.cloudManage'),
    icon: communication,
    active: communicationA,
    router: 'cloud',
    code: '5',
    children: [
      {
        code: '5',
        label: t('MENU.cloudAccount'),
        router: '/cloud/account',
      },
      {
        code: '5',
        label: t('MENU.cloudPush'),
        router: '/cloud/message',
      },
      {
        code: '5',
        label: t('MENU.cloudApiList'),
        router: '/cloud/api-list',
      },
    ],
  },
  {
    label: t('MENU.warningManage'),
    icon: warning,
    active: warningA,
    router: 'warning',
    code: '3',
    children: [
      {
        label: t('MENU.warningTactics'),
        router: '/warning/tactics',
        code: '3-1',
      },
      {
        code: '3-3',
        label: t('MENU.warningContact'),
        router: '/warning/contact',
      },
      {
        code: '3-3',
        label: t('MENU.warningPush'),
        router: '/warning/push',
      },
      {
        code: '3-2',
        label: t('MENU.warningMsg'),
        router: '/warning/warning-message',
      },
    ],
  },
  {
    label: t('MENU.configManage'),
    icon: conf,
    active: confA,
    router: 'config',
    code: '4',
    children: [
      {
        code: '4-1',
        label: t('MENU.configUser'),
        router: '/config/user',
      },
      {
        code: '4-4',
        label: t('MENU.rolesConfiguration'),
        router: '/config/role',
      },
      {
        code: '4-2',
        label: t('MENU.configLog'),
        router: '/config/log',
      },
      {
        code: '4-3',
        label: t('MENU.configOrgManage'),
        router: '/config/org',
      },
    ],
  },
]

const authMenu: any = ref([])

// fuck
// const getAuthMenu = () => {
//   return menuData
//     .map((item: any) => {
//       const { code, children, codeList }: any = item
//       if (!item.code) return item

//       if (
//         authStore.resources.includes(code) ||
//         validateCodeList(codeList || [])
//       ) {
//         if (!children) {
//           return item
//         }
//         const moChildren = children.filter((v: any) => {
//           console.log(v.code, 'v.code')
//           return (
//             authStore.resources.includes(v.code) ||
//             validateCodeList(v.codeList || [])
//           )
//         })
//         return {
//           ...item,
//           children: moChildren,
//         }
//       }
//     })
//     .filter(Boolean)
// }

const getAuthMenu = (list: any) => {
  return list
    .map((item: any) => {
      const { code, children, codeList }: any = item
      if (!item.code) return item

      if (
        authStore.resources.includes(code) ||
        validateCodeList(codeList || [])
      ) {
        if (!children) {
          return item
        } else {
          const moChildren = getAuthMenu(children)
          return {
            ...item,
            children: moChildren,
          }
        }
      }
    })
    .filter(Boolean)
}

const validateCodeList = (codeList: any) => {
  return codeList.some((code: any) => {
    return authStore.resources.includes(code)
  })
}

console.log(validateCodeList([]))

authMenu.value = getAuthMenu(menuData)

const defaultActive = ref('')

const $route = useRoute()

watch($route, () => {
  matchPath()
})

watch(
  () => authStore.resources,
  () => {
    authMenu.value = getAuthMenu(menuData)
  }
)

onMounted(() => {
  matchPath()
})

const matchPath = () => {
  defaultActive.value = $route.path
}

const select = (router: string) => {
  defaultActive.value = router
  if (router === '/statistics/bigscreen-farm') {
    farmStore.changeKey('farm')
  } else if (router === '/statistics/bigscreen-park') {
    farmStore.changeKey('park')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "active-text-color": "#186DF5",
      "default-active": defaultActive.value,
      "text-color": "#4E5969",
      router: "",
      onSelect: select
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(authMenu.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (!item.children)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: item.router
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: defaultActive.value === item.router ? item.active : item.icon,
                      alt: ""
                    }, null, 8, _hoisted_2),
                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["index"]))
              : (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: 1,
                  index: item.router
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("img", {
                      src: item.icon,
                      alt: ""
                    }, null, 8, _hoisted_3),
                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (vv, ii) => {
                      return (_openBlock(), _createElementBlock("div", { key: ii }, [
                        (vv.children)
                          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                              key: 0,
                              index: vv.router
                            }, {
                              title: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(vv.label), 1)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vv.children, (vvv, iii) => {
                                  return (_openBlock(), _createBlock(_component_el_menu_item, {
                                    index: vvv.router,
                                    key: iii
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(vvv.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["index"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["index"]))
                          : (_openBlock(), _createBlock(_component_el_menu_item, {
                              key: 1,
                              index: vv.router
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(vv.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["index"]))
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}
}

})